import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { ScholarshipAwardDurationDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-scholarship-duration-view',
  templateUrl: './scholarship-duration-view.component.html',
  styleUrls: ['./scholarship-duration-view.component.css'],
})
export class ScholarshipDurationViewComponent implements OnInit {
  @Input() scholarshipAwardDurations: ScholarshipAwardDurationDto[];
  scholarshipAwardDurationForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<ScholarshipAwardDurationDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.scholarshipAwardDurationForm = this.fb.group({
      ScholarshipAwardDurations: this.fb.array([]),
    });
    console.log(this.scholarshipAwardDurations);
    this.setScholarshipAwardDuration();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display scholarshipAwardDurations
  setScholarshipAwardDuration() {
    const control = this.scholarshipAwardDurationForm.controls
      .ScholarshipAwardDurations as FormArray;
    this.scholarshipAwardDurations.forEach((e) => {
      control.push(
        this.fb.group({
          ScholarshipAwardDurationName: e.ScholarshipAwardDurationName,
          id: e.id,
        })
      );
    });
  }

  // method to add ScholarshipAwardDuration
  addScholarshipAwardDuration() {
    const control = this.scholarshipAwardDurationForm.controls
      .ScholarshipAwardDurations as FormArray;
    control.insert(
      0,
      this.fb.group({
        ScholarshipAwardDurationName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete scholarshipAwardDuration from arrary list
  deleteScholarshipAwardDuration(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.scholarshipAwardDurationForm.controls
          .ScholarshipAwardDurations as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.scholarshipAwardDurations.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.scholarshipAwardDurations[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'scholarshipAwardDuration';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('scholarshipAwardDuration');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
